import { AnyAction, Reducer } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'
import { combineReducers } from 'redux'

import { LLC_ACCESS_TOKEN } from '@configs'
import aboutusManagementReducer from './aboutus-management'
import appReducer from './app'
import applicationReducer from './application-management'
import authReducer from './auth'
import blogReducer from './blog-news'
import careerLandingReducer from './careerLanding-management'
import categoriesReducer from './category-management'
import chatReducer from './chat'
import contentSlice from './content-management'
import courseReducer from './course'
import courseRequestReducer from './course-request-management'
import dashboardSlice from './dashboard'
import emailContentReducer from './email-content-management'
import emailSubscribed from './email-subscribed'
import evolveLandingReducer from './evolveLanding-management'
import galleryReducer from './gallery'
import groupUserReducer from './group-user-management'
import habitReducer from './habit-management'
import homeContentReducer from './home-page-management'
import layoutReducer from './layout'
import lessonReducer from './lesson'
import megaMenuReducer from './mega-menu'
import notificationReducer from './notification'
import notificationsSlice from './notification-management'
import packageReducer from './package-management'
import planReducer from './plan'
import postReducer from './post-management'
import roleReducer from './role-management'
import seoConfigReducer from './seo-config'
import teacherLandingReducer from './teacher-landing-page'
import teacherManagementReducer from './teacher-management'
import teacherPackageReducer from './teacher-package-management'
import teacherRequestReducer from './teacher-request-management'
import testManagementReducer from './test-management'
import tierReducer from './tier'
import toastReducer from './toast'
import userLogReducer from './user-log'
import usersSlice from './user-management'
import userSlice from './userSlice'
import eventPostsReducer from './event-posts'
import workshopEventSlice from './workshop-event'
import cartSlice from './cart-management'

export * from './aboutus-management'
export * from './app'
export * from './auth'
export * from './blog-news'
export * from './chat'
export * from './content-management'
export * from './course'
export * from './course-request-management'
export * from './dashboard'
export * from './email-content-management'
export * from './gallery'
export * from './group-user-management'
export * from './habit-management'
export * from './layout'
export * from './lesson'
export * from './mega-menu'
export * from './notification'
export * from './notification-management'
export * from './package-management'
export * from './plan'
export * from './role-management'
export * from './seo-config'
export * from './teacher-landing-page'
export * from './teacher-management'
export * from './teacher-package-management'
export * from './teacher-request-management'
export * from './test-management'
export * from './tier'
export * from './toast'
export * from './user-log'
export * from './user-management'
export * from './userSlice'
export * from './event-posts'

const productReducer = combineReducers({
  toast: toastReducer,
  app: appReducer,
  auth: authReducer,
  layout: layoutReducer,
  tier: tierReducer,
  user: userSlice,
  plans: planReducer,
  users: usersSlice,
  notifications: notificationsSlice,
  dashboard: dashboardSlice,
  role: roleReducer,
  package: packageReducer,
  userLog: userLogReducer,
  content: contentSlice,
  chat: chatReducer,
  categories: categoriesReducer,
  emailsSub: emailSubscribed,
  blog: blogReducer,
  course: courseReducer,
  lesson: lessonReducer,
  aboutUsManagement: aboutusManagementReducer,
  gallery: galleryReducer,
  habit: habitReducer,
  post: postReducer,
  groupUser: groupUserReducer,
  emailContent: emailContentReducer,
  homePageManagement: homeContentReducer,
  seoConfig: seoConfigReducer,
  teacherManagement: teacherManagementReducer,
  testManagement: testManagementReducer,
  teacherPackages: teacherPackageReducer,
  teacherRequestManagement: teacherRequestReducer,
  courseRequestManagement: courseRequestReducer,
  notification: notificationReducer,
  teacherLanding: teacherLandingReducer,
  evolveLanding: evolveLandingReducer,
  careerLanding: careerLandingReducer,
  application: applicationReducer,
  megaMenu: megaMenuReducer,
  eventPosts: eventPostsReducer,
  workshopEvents: workshopEventSlice,
  carts: cartSlice,
})

export type RootState = ReturnType<typeof productReducer>

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'RESET') {
    // reset state
    state = {} as RootState
    // reset local storage
    Cookies.remove(LLC_ACCESS_TOKEN)
    sessionStorage.clear()
  }
  return productReducer(state, action)
}
export default rootReducer
